import type { DirectusSchema } from '@/types/directus-types'
import { authentication, createDirectus, rest } from '@directus/sdk'

/** Base URL for the directus services and storage. */
const directusBaseURL = import.meta.env.VITE_BACKEND_URL

/** Directus asset storage path extension. */
export const directusAssetsRoute = directusBaseURL + '/assets/'

/**
 * Accepted strings for directus collection names.
 *
 * NOTE: there should also be a file handling all interactions with each collection
 * e.g. `asset-bookings-calls.ts` for `"Asset_Bookings"`.
 */
export type CollectionNames = 
  | 'Asset_Bookings'
  | 'Car_Record'
  | 'Driver'
  | 'EV_Model_Assets'
  | 'ManagedContent'
  | 'NetworkBranding'
  | 'Optimiser_Settings'
  | 'Favourite_Locations'
  | 'SavedRoutePlans'
  | 'Car_Record_files'
  | 'BookableChargerUnit'

export type SingletonNames = 'Company'

class LocalStorage {
  get() {
    return JSON.parse(localStorage.getItem('directus-data') || '{}')
  }
  set(data) {
    localStorage.setItem('directus-data', JSON.stringify(data))
  }
  clear() {
    localStorage.removeItem('directus-data')
  }
}

export const storage = new LocalStorage()

/** Local directus client. */
const directus = createDirectus<DirectusSchema>(directusBaseURL)
  .with(authentication('json', { storage }))
  .with(
    rest({
      onRequest: (options) => ({
        ...options,
        headers: {
          ...options.headers,
          'cache-control': 'no-store',
        },
      }),
    }),
  )

export default directus
